__webpack_require__.p = "/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/";